import {useSelector} from 'react-redux'

const useLocalStorageFetch = () => {
  const dataUser: any = useSelector((state) => state)

  // const role = dataUser?.auth?.role?.toLowerCase().replaceAll('_', '')
  const role =
    dataUser?.auth?.businessProfileRole === 'Staff' && dataUser?.auth?.role === 'Doctor'
      ? `${dataUser?.auth?.role?.toLowerCase().replaceAll('_', '')}/staff`
      : dataUser?.auth?.role?.toLowerCase().replaceAll('_', '')
  return {dataUser, role}
}

export default useLocalStorageFetch
